'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/pstatuses/:pstatusId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/pstatuses/:pstatusId/enable', method: 'PUT'},
            delete: {url: 'api/pstatuses/:pstatusId/delete', method: 'PUT'},
            getDefault: {url: 'api/pstatuses/default', method: 'GET'},
            setDefault: {url: 'api/pstatuses/:pstatusId/default', method: 'PUT'},
            isUniqueName: {url: 'api/pstatuses/unique/name/:name', method: 'GET'}
        });
    }];